import React from 'react';
import styled from 'styled-components';
import { AppColors } from 'helpers';
import { Div, HorizontalView, VerticalView } from 'vendor-deprecated/Wrapper';
import { TextDisplay } from 'vendor-deprecated/Text';
import { SVGIcon } from 'vendor-deprecated/Icon';
import { useTranslationText } from 'locale';
import { ICourse } from 'types/types';
import { Image } from 'components/common/vendors/Image';
import { friendlyURL } from 'helpers/commonUtils';
import { useAppSetting } from 'helpers/useAppSetting';
import { ALink } from 'vendor-deprecated/ALink';
import NumberFormat from 'react-number-format';
import { RateBar } from 'vendor-deprecated/Rate';

const CourseTitle = styled.div`
  font-size: 34px;
  line-height: 40px;
  font-weight: 600;
  border-bottom: 2px solid white;
`;

const DescriptionWrapper = styled.div`
  margin-top: 10px;
  font-size: 18px;
`;

const Avatar = styled.div`
  border-radius: 50%;
  border: 1px solid white;
  overflow: hidden;
`;

const i18key = 'public.courseDetails';

export const Information = React.memo((props: { type: 'white' | 'dark'; course: ICourse }) => {
  const { translation } = useTranslationText();
  return (
    <VerticalView fullWidth alignContent={'centerLeft'} marginTop={'10px'} paddingBottom={'20px'}>
      <HorizontalView height={'100%'} alignContent={'center'} marginTop={'10px'} flexWrap={'nowrap'}>
        <SVGIcon name={'clock'} size={'14px'} color={props.type === 'white' ? AppColors.WHITE : AppColors.DARK} />
        <TextDisplay
          marginLeft={'10px'}
          size={'15px'}
          color={props.type === 'white' ? AppColors.WHITE : AppColors.DARK}
        >
          {translation(`${i18key}.duration`)}:
        </TextDisplay>
        <TextDisplay
          fontWeight={'bold'}
          marginLeft={'10px'}
          size={'15px'}
          color={props.type === 'white' ? AppColors.WHITE : AppColors.DARK}
        >
          {props.course.duration} {` `}
          {translation(`${i18key}.unitTime`)}
        </TextDisplay>
      </HorizontalView>
      <HorizontalView height={'100%'} alignContent={'center'} marginTop={'10px'} flexWrap={'nowrap'}>
        <SVGIcon name={'clock'} size={'15px'} color={props.type === 'white' ? AppColors.WHITE : AppColors.DARK} />
        <TextDisplay
          marginLeft={'10px'}
          size={'15px'}
          color={props.type === 'white' ? AppColors.WHITE : AppColors.DARK}
        >
          {translation(`${i18key}.syllabus`)}:
        </TextDisplay>
        <TextDisplay
          fontWeight={'bold'}
          marginLeft={'10px'}
          size={'15px'}
          color={props.type === 'white' ? AppColors.WHITE : AppColors.DARK}
        >
          {props.course.lessons?.length} {` `}
          {translation(`${i18key}.lesson`)}
        </TextDisplay>
      </HorizontalView>
    </VerticalView>
  );
});

export const CourseRating = React.memo((props: { course: ICourse }) => {
  const { appSize } = useAppSetting();
  const { translation } = useTranslationText();

  return (
    <Div>
      <TextDisplay size={appSize.h4} marginTop={'2px'}>
        <NumberFormat
          thousandSeparator={','}
          displayType={'text'}
          value={props.course.owner?.avgRate}
          renderText={(value) => <>{parseFloat(value).toFixed(1)}</>}
        />
      </TextDisplay>

      <Div width={'10px'} />
      <RateBar disabled value={props.course.owner?.avgRate ? props.course.owner?.avgRate : 0} />
      <Div width={'15px'} />
      <TextDisplay size={appSize.h4} marginTop={'2px'}>
        (<NumberFormat thousandSeparator={','} displayType={'text'} value={props.course.owner?.totalReviews} />
        {` ${translation('rating')}`})
      </TextDisplay>
    </Div>
  );
});

export const CourseDescription = React.memo((props: { course: ICourse; hideCover?: boolean }) => {
  const { appLayout, appSize } = useAppSetting();
  const { course } = props;

  return (
    <Div fullWidth>
      <VerticalView fullWidth alignContent={'centerLeft'}>
        {appLayout.isMobile && !props.hideCover && (
          <Div
            fullWidth
            overflow={'hidden'}
            border={`1px solid ${AppColors.GRAY_LIGHT}`}
            alignContent={'topCenter'}
            marginBottom={'20px'}
            borderRadius={'4px'}
          >
            <Image src={props.course.thumbnail || '/images/course.png'} objectFit={'cover'} width={'100%'} />
          </Div>
        )}

        <CourseTitle>{course.title}</CourseTitle>
        <DescriptionWrapper>{course.description}</DescriptionWrapper>
        <Information type={'white'} course={props.course} />
        <CourseRating course={course} />
        {props.course && props.course.owner && !appLayout.isMobile && (
          <HorizontalView paddingTop={'10px'}>
            <Avatar>
              <Image
                width={'30px'}
                height={'30px'}
                src={props.course.owner.profilePath || '/images/avatar.png'}
                objectFit={'cover'}
              />
            </Avatar>
            <ALink
              marginLeft={'10px'}
              color={AppColors.WHITE}
              fontWeight={500}
              size={appSize.h3}
              href={`/teacher/${friendlyURL(props.course.owner.id, props.course.owner.name || 'teacher')}`}
            >
              {props.course.owner.name}
            </ALink>
          </HorizontalView>
        )}
      </VerticalView>
    </Div>
  );
});
